/** Whether buyer can use delivered_prompt actions (matches backend deliveredPromptEligibleAt). */
export function isDeliveredPromptActionable(systemData) {
  if (!systemData || systemData.event !== "delivered_prompt") return false;
  if (systemData.resolution) return false;

  const eligibleRaw = systemData.promptEligibleAt;
  if (!eligibleRaw) {
    // Legacy prompts posted before ETA guard — hide actions; buyer uses track order page.
    return false;
  }

  const eligibleAt = new Date(eligibleRaw);
  if (Number.isNaN(eligibleAt.getTime())) return false;
  return Date.now() >= eligibleAt.getTime();
}

export function formatDeliveredPromptEligibleDate(systemData) {
  const eligibleRaw = systemData?.promptEligibleAt;
  if (!eligibleRaw) return "";
  const d = new Date(eligibleRaw);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
